/* eslint-disable no-console-log/no-console-log */

class LoggerHelper {
  static log(...message: any[]) {
    console.log(...message);
  }

  static error(...message: any[]) {
    console.error(...message);
  }
}

export { LoggerHelper };
